import React from 'react';
import { Outlet } from 'react-router-dom';
import AnalyticsSidebar from './sidebar';

function AnalyticsLayout() {
    return (
        <div className="flex">
            <AnalyticsSidebar />
            <main className="flex-1 p-4">
                <Outlet />
            </main>
        </div>
    );
}

export default AnalyticsLayout;